import React, { useMemo } from 'react';
import { generateContainerStyles } from 'components/Container/ContainerStyles';
import { Box } from '@mui/material';

export function Container({ children }: { children: React.ReactNode}) {
    const styles = useMemo(() => generateContainerStyles(), []);

    return (
        <Box sx={styles.container}>{children}</Box>
    );
}
